import * as React from "react";
const SvgRadioIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 18, height: 18, rx: 9, stroke: "white", strokeWidth: 2 }));
export default SvgRadioIcon;
